import { useState } from 'react'
import classNames from 'classnames'
import { ReactComponent as BoxesIcon } from '@/assets/icons/boxes-icon.svg'
import { ReactComponent as EllipsisIcon } from '@/assets/icons/ellipsis-icon.svg'
import './BoxesButtons.scoped.sass'
import { EditDropdownMenu } from './EditDropdownMenu/EditDropdownMenu'
import dropdownService from '@/components/DropdownMenu/dropdown.service'
import boxesService from '@/app-domains/boxes/boxes.service'
import useRenderEvent from '@/core/hooks/useRenderEvent'

function BoxesButton (props) {
  const [menuOpened, setMenuOpened] = useState(false)
  const [menuOpenedEvent, setMenuOpenedEvent] = useState(false)
  const { selectedBoxes, setSelectedBoxes, box, selectedBox, selectBox } = props
  const [isMarked, setIsMarked] = useState(false)
  
  const toggleMenuOpen = (e) => {
    e.stopPropagation()
    if (dropdownService.isOpenedForThisTarget(e)) {
      setMenuOpened(false)
      setMenuOpenedEvent(false)
      return dropdownService.close()
    }
    setMenuOpenedEvent(e)
    setMenuOpened(Date.now())
  }

  useRenderEvent(['DROPDOWN:CLOSE'], () => {
    setMenuOpened(false)
    setMenuOpenedEvent(false)
  })

  useRenderEvent([`${box.id}:UNMARKED`], () => {
    setIsMarked(false)
  })

  return <li id={'box-button' + box.id} key={box.id} className={classNames({ active: selectedBox === box.id, 'menu-opened': menuOpened })} onClick={() => selectBox(box)}>
    <div className="label-left">
      <span className='label-icon'>
        <BoxesIcon />
      </span>
      <div className="label-name">
        {box.boxalias ? box.boxalias : box.boxname}
      </div>
    </div>
    <div className="boxes-button-right-menu">
      <div className={classNames('mark-box', { active: isMarked === true })}>
        <input type='checkbox' checked={isMarked} onClick={(e) => {
          e.stopPropagation()
          setIsMarked(!isMarked)
          const boxArr = [box]
          if (isMarked === false) {
            const newArr = selectedBoxes.concat(boxArr)
            setSelectedBoxes(newArr)
            boxesService.saveSelectedBoxes(newArr)
          } else {
            const filteredArr = selectedBoxes.filter((selectedBox) => selectedBox.id !== box.id)
            setSelectedBoxes(filteredArr)
            boxesService.saveSelectedBoxes(filteredArr)
          }
        }
        }/>
      </div>
      <div className="label-right">
        {box.msgunopen}
      </div>
      <div className="boxes-button-dropdown-button">
        <EllipsisIcon onClick={toggleMenuOpen} />
        {menuOpened && <EditDropdownMenu box={box} event={menuOpenedEvent} />}
      </div>
    </div>
  </li>
}
export function BoxesButtons ({ currentBoxes, selectedBox, selectBox, selectedSortType, setScrollLock }) {
  const [selectedBoxes, setSelectedBoxes] = useState(boxesService.getSelectedBoxesFromStore() || [])
  useRenderEvent(['SELECTED_BOXES:UPDATED'], () => {
    setSelectedBoxes(boxesService.getSelectedBoxesFromStore())
  })
  const sorts = {
    none: () => {},
    'A-Z': (a, b) => a.boxname.localeCompare(b.boxname),
    Unread: (a, b) => b.msgtotal - a.msgtotal,
    'Created at': (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
    'Updated at': (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
  }
  
  return (currentBoxes || []).length > 0
    ? currentBoxes
      .slice()
      .sort(sorts[selectedSortType] || sorts.none)
      .map((box) => <BoxesButton setScrollLock={setScrollLock} selectedBoxes={selectedBoxes} setSelectedBoxes={setSelectedBoxes} box={box} key={box.id} selectedBox={selectedBox} selectBox={selectBox} />)
    : <div className="no-boxes-in-label-placeholder">There aren't any Boxes attached to this label</div>
}
